import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardName',
  standalone: true
})
export class CardNamePipe implements PipeTransform {

  transform(value: string): string {
    switch(value.toLowerCase()) {
      case 'vi':
        return 'Visa';
      case 'mc':
        return 'MasterCard';
      case 'di':
        return 'Discover';
      default:
        return value;
    }
  }

}
